import getLocalString from "constants/Localization";
import { useUpdateDailyFormVehicleMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useUpdateDailyFormVehicle() {
  const [mutation, { loading, data, error }] = useUpdateDailyFormVehicleMutation({
    refetchQueries: ["getDailyFormVehicles"],
  });

  const [updateDailyFormVehicle, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "updateDailyFormVehicle",
    },
    {
      successMessage: getLocalString("fleet.update-vehicle-success"),
      failureMessage: getLocalString("fleet.update-vehicle-failure"),
    }
  );

  return [updateDailyFormVehicle, context] as const;
}
